import React from "react";

export const ParametersSvg = () => {
  return (
    <svg
      data-name="Group 21"
      width={169.666}
      height={175.863}
      viewBox="0 0 169.666 175.863"
    >
      <path
        data-name="Path 18"
        d="M123.753 128.372l-.295 8.023c-.044 1.19-.077 2.38-.132 3.568-.04.877-.74 2.825-.022 1.468l4.183-5.17a17.462 17.462 0 012.194-.704l-3.581.544q-3.579.538-7.162 1.069-6.266.92-12.541 1.802-12.994 1.83-26.014 3.478-26.487 3.364-53.059 6.001l14.424 11.661a3.617 3.617 0 01-1.067 3.394 25.513 25.513 0 011.745-2.206c.978-1.16 2.042-2.259 3.051-3.397q3.693-4.164 7.179-8.51 6.467-8.075 12.168-16.72c4.263-6.465 8.283-13.112 11.955-19.93 3.5-6.507 7.76-13.597 8.35-21.093.802-10.172-5.885-16.898-12.63-23.467A210.31 210.31 0 0055.68 53.78c-5.398-4.252-10.882-8.41-16.196-12.768-4.496-3.687-10.936-8.562-12.083-12.598l.732 6.935.15-1.223-2.747 6.109a4.088 4.088 0 01-.884.797c.858.035 2.695-1.024 3.628-1.28 2.384-.66-1.326.24 1.113-.24 1.273-.252 2.551-.46 3.83-.673a714.154 714.154 0 0115.193-2.324q16.114-2.305 32.314-3.94 15.742-1.59 31.544-2.542c1.384-.08 4.212-.426 4.29-.113.002.022-1.373-.862-1.477-.946a1.619 1.619 0 01-.622-.933c-.071.09.836 2.962.372.565.16.812.266 1.636.345 2.46.11 1.046.13 2.1.159 3.15.064 2.281.193-3.025-.024.817-.393 7.065 3.284 13.848 10.806 15.087 6.401 1.052 14.688-3.694 15.083-10.806.595-10.691-.052-23.064-9.229-30.328-10.048-7.953-24.186-5.024-35.99-4.106-23.323 1.809-47.17 3.942-70.11 8.695-5.712 1.18-11.684 2.648-16.528 6.086C1.855 24.98.316 34.053 4.766 41.89c5.46 9.603 14.62 16.738 23.163 23.493 8.278 6.551 16.802 12.822 24.616 19.945 1.75 1.595 3.492 3.212 5.135 4.92 1.104 1.15-.612.003 1.445 1.594l.948 1.229-.892-4.232.247-.343c-.356.95-.754 1.89-1.196 2.803-.435.964-.913 1.92-1.376 2.87q-1.922 3.932-3.996 7.785a198.049 198.049 0 01-18.139 27.809c-7.675 9.934-20.22 19.297-19.066 33.103.598 7.097 7.47 12.36 14.423 11.667q34.223-3.41 68.314-7.99c11.06-1.49 22.127-3.005 33.148-4.761 7.019-1.12 13.228-3.75 16.292-10.717 2.403-5.46 1.591-12.576 1.808-18.406.26-7.07-3.19-13.835-10.803-15.087-6.297-1.037-14.822 3.677-15.087 10.803z"
        opacity={0.08}
      />
      <g
        data-name="Group 20"
        transform="translate(79.964 46.392)"
        fill="#ed1b2e"
      >
        <path data-name="Rectangle 7" d="M17.973 8.471h71.156v3.683H17.973z" />
        <path data-name="Rectangle 8" d="M0 36.02h89.129v4.125H0z" />
        <path data-name="Rectangle 9" d="M0 62.39h88.098v4.272H0z" />
        <circle
          data-name="Ellipse 4"
          cx={9.944}
          cy={9.944}
          transform="translate(.516)"
          r={9.944}
        />
        <circle
          data-name="Ellipse 5"
          cx={9.944}
          cy={9.944}
          transform="translate(35.725 27.328)"
          r={9.944}
        />
        <circle
          data-name="Ellipse 6"
          cx={9.944}
          cy={9.944}
          transform="translate(69.814 52.446)"
          r={9.944}
        />
      </g>
    </svg>
  );
};
